import { createBrowserRouter } from "react-router-dom";

import Home from "../pages/dashboard/Home.jsx";

import Logout from "../pages/Logout.jsx";
import GuestLayout from "../layouts/GuestLayout";
import AdminLayout from "../layouts/AdminLayout";
import NotFound from "../pages/NotFound.jsx";
import Login from "../pages/Login";
import UsersHome from "../pages/users/UsersHome";
import Users from "../pages/users/Users";
import AddUser from "../pages/users/AddUser";
import NewsHome from "../pages/News/NewsHome";
import News from "../pages/News/News";
import AddNews from "../pages/News/AddNews";
import EditeNews from "../pages/News/EditeNews";
import RequestHome from "../pages/Request/RequestHome";
import Requests from "../pages/Request/Requests";
import InvitationsHome from "../pages/Invitations/InvitationsHome";
import Invitations from "../pages/Invitations/Invitations";
import AddInvitations from "../pages/Invitations/AddInvitations";
import Request from "../pages/Request/Request";
import AttendantHome from "../pages/ِِAttendant/AttendantHome";
import Attendants from "../pages/ِِAttendant/Attendants";
import Attendant from "../pages/ِِAttendant/Attendant";
import Notification from "./Notification";
import Notifications from "../pages/Notifications";
import Account from "../pages/profile/Account.jsx";
import AccountView from "../pages/profile/AccountView.jsx";
import AccountEdite from "../pages/profile/AccountEdite";
import AccountSetting from "../pages/profile/AccountSetting";

import PaperHome from "../pages/Papers/PaperHome";
import Papers from "../pages/Papers/Papers";
import Paper from "../pages/Papers/Paper";
import QrGenrator from "../pages/QrGenrator";
import User from "../pages/users/User.jsx";
import EditAttendant from "../pages/ِِAttendant/EditAttendant.jsx";
import SponsersHome from "../pages/Sponsers/SponsersHome.jsx";
import Sponsers from "../pages/Sponsers/Sponsers.jsx";
import AddSponser from "../pages/Sponsers/AddSponser.jsx";
import EditSponsor from "../pages/Sponsers/EditeSponser.jsx";
import ETL from "../pages/ETL/ETL.jsx";
import Cities from "../pages/ETL/Cities.jsx";
import NamesProcess from "../pages/ETL/NamesProcess.jsx";
import ExcelInvitations from "../pages/Invitations/ExcelInvitations.jsx";
import SpeakerHome from "../pages/Speakers/SpeakerHome.jsx";
import Speakers from "../pages/Speakers/Speakers.jsx";
import AddSpeaker from "../pages/Speakers/AddSpeaker.jsx";
import EditeSpeaker from "../pages/Speakers/EditeSpeaker.jsx";
import ContactHome from "../pages/Contact/ContactHome.jsx";
import Contacts from "../pages/Contact/Contacts.jsx";
import SpeakerList from "../pages/Speakers/SpeakerList.jsx";
import Files from "../pages/Files/Files.jsx";
import FilesHome from "../pages/Files/FilesHome.jsx";
import AddFile from "../pages/Files/AddFile.jsx";
import EditFile from "../pages/Files/EditFile.jsx";
import FileReplacementForm from "../pages/Files/FileReplacementForm.jsx";
import SlidsHome from "../pages/Slides/SlidsHome.jsx";
import Slides from "../pages/Slides/Slides.jsx";
import AddSlider from "../pages/Slides/AddSlider.jsx";
import SectionsHome from "../pages/sections/SectionsHome.jsx";
import Sections from "../pages/sections/Sections.jsx";
import AddSection from "../pages/sections/AddSection.jsx";
import EditeSections from "../pages/sections/EditeSections.jsx";
import SectionSort from "../pages/sections/SectionSort.jsx";
import DeclinedHome from "../pages/Declined/DeclinedHome.jsx";
import Declineds from "../pages/Declined/Declineds.jsx";
import Declined from "../pages/Declined/Declined.jsx";
import NDashboard from "../pages/newdaboard/NDashdoard.jsx";
import UsersDataTable from "../pages/newdaboard/UsersDataTable.jsx";

// JSX  
const router = createBrowserRouter([

    {
        path:"/" ,
        element: <GuestLayout/>, 
        children: [
            {
                path:"/" , 
                element: <Login/>
            }
        ]
         
    },
    {
        path: "/",
        element: <AdminLayout />,
        children: [
            {
                path: "/dashboard",
                element: <NDashboard />
            },
            ,
            {
                path: "/dashboard/reports",
                element: <UsersDataTable />
            },
            {
                path:"/news",
                element : <NewsHome/> ,
                children:[
                    {
                        path: "/news" ,  
                        element :<News/>
                    }, {
                        path:"/news/Add" , 
                        element:<AddNews/> 
                    },
                    {
                        path:"/news/Edite/:id", 
                        element: <EditeNews/>
                    },
                     ]
                    },
                    {
                        path:"/sections",
                        element : <SectionsHome/> ,
                        children:[
                            {
                                path: "/sections" ,  
                                element :<Sections/>
                            }, 
                            {
                                path: "/sections/sort/:id/:lang" ,  
                                element :<SectionSort/>
                            },
                            {
                                path:"/sections/Add" , 
                                element:<AddSection/> 
                            },
                            {
                                path:"/sections/Edite/:id", 
                                element: <EditeSections/>
                            },
                             ]
                            },
                    {
                        path:"/sliders",
                        element : <SlidsHome/> ,
                        children:[
                            {
                                path: "/sliders" ,  
                                element :<Slides/>
                            },
                            {
                                path: "/sliders/Add" ,  
                                element :<AddSlider/>
                            } 
                             ]
                            }
                    ,
                    {
                        path:"/contacts",
                        element : <ContactHome/> ,
                        children:[
                            {
                                path: "/contacts" ,  
                                element :<Contacts/>
                            }, 
                             ]
                            },
                    {
                        path:"/Sponsers",
                        element : <SponsersHome/> ,
                        children:[
                            {
                                path: "/Sponsers" ,  
                                element :<Sponsers/>
                            }, {
                                path:"/Sponsers/Add/:id" , 
                                element:<AddSponser/> 
                            },
                            {
                                path:"/Sponsers/Edit/:id", 
                                element: <EditSponsor/>
                            },
                             ]
                            },
                            {
                                path:"/speakers",
                                element : <SpeakerHome/> ,
                                children:[
                                    {
                                        path: "/speakers" ,  
                                        element :<Speakers/>
                                    }, {
                                        path:"/speakers/Add/:id" , 
                                        element:<AddSpeaker/> 
                                    },
                                    , {
                                        path:"/speakers/sort/:id" , 
                                        element:<SpeakerList/> 
                                    },
                                    {
                                        path:"/speakers/Edit/:id", 
                                        element: <EditeSpeaker/>
                                    },
                                     ]
                                    },
                    {
                        path: "/Users/" , 
                        element: <UsersHome/> , 
                        children : [
                            {
                                path:"/Users/" , 
                                element : <Users/> 
                            } , 
                            {
                                path: "/Users/Add" , 
                                element: <AddUser/> 
                            },
                        ]
                    },
                    {
                        path: "/files/" , 
                        element: <FilesHome/> , 
                        children : [
                            {
                                path:"/files/" , 
                                element : <Files/> 
                            } , 
                            {
                                path:"/files/Edite/:id" , 
                                element : <EditFile/> 
                            } , 
                            , 
                            {
                                path:"/files/replace/:id" , 
                                element : <FileReplacementForm /> 
                            } , 
                            {
                                path: "/files/Add" , 
                                element: <AddFile/> 
                            },
                        ]
                    }
                   
                    
                    ,
                    {
                        path: "/Invitations/" , 
                        element: <InvitationsHome/> , 
                        children : [
                            {
                                path:"/Invitations/" , 
                                element : <Invitations/> 
                            } , 
                            {
                                path: "/Invitations/Add" , 
                                element: <AddInvitations/> 
                            },
                            {
                                path: "/Invitations/Add/excel" , 
                                element: <ExcelInvitations/> 
                            },
                        ]
                    }
                   
                    ,
                    {
                        path: "/Requests/" , 
                        element: <RequestHome/> , 
                        children : [
                            {
                                path:"/Requests/" , 
                                element : <Requests/> 
                            } , 
                            {
                                path:"/Requests/:id" , 
                                element : <Request/> 
                            } , 
                         
                        ]
                    }
                    ,
                    {
                        path: "/Decliends/" , 
                        element: <DeclinedHome/> , 
                        children : [
                            {
                                path:"/Decliends/" , 
                                element : <Declineds/> 
                            } , 
                            {
                                path:"/Decliends/:id" , 
                                element : <Declined/> 
                            } , 
                         
                        ]
                    }
                    ,
                    {
                        path: "/Attendants/" , 
                        element: <AttendantHome/> , 
                        children : [
                            {
                                path:"/Attendants/" , 
                                element : <Attendants/> 
                            } , 
                            {
                                path:"/Attendants/:id" , 
                                element : <Attendant/> 
                            } , 

                            {
                                path:"/Attendants/:id/Edite" , 
                                element : <EditAttendant/> 
                            } , 
                         
                        ]
                    },
                    
                    {
                        path: "/Papers/" , 
                        element: <PaperHome/> , 
                        children : [
                            {
                                path:"/Papers/" , 
                                element : <Papers/> 
                            } , 
                            {
                                path:"/Papers/:id" , 
                                element : <Paper/> 
                            } , 
                         
                        ]
                    },
                     {
                        path:"/notifications" , 
                        element:<Notifications/>
                    },{
                        path:'/Account/' , 
                        element: <Account/> , 
                        children : [
                            {
                                path:'/Account/View' , 
                                element: <AccountView/>
                            } , 
                            {
                                path:'/Account/' , 
                                element: <AccountView/>
                            } , 
                            {
                                path:'/Account/edite' , 
                                element: <AccountEdite/>
                            }
                            , 
                            {
                                path:'/Account/Settings' , 
                                element: <AccountSetting />
                            }
                            
                        ]
                    },{
                        path:"/QRCodeGenerator", 
                        element:<QrGenrator/>
                    },{
                        path:"/ETL", 
                        element:<ETL/>,
                        children:[
                            ,{
                                path:"/ETL/names", 
                                element:<NamesProcess/>
                            },{
                                path:"/ETL/Cities", 
                                element: <Cities/>
                            }
                        ]
                    },
                    {
                        path: "/Users/" , 
                        element: <UsersHome/> , 
                        children : [
                            {
                                path:"/Users/" , 
                                element : <Users/> 
                            } , 
                            
                            {
                                path: "/Users/Add" , 
                                element: <AddUser/> 
                            },
                            {
                                path:"/Users/:id" , 
                                element : <User/> 
                            } , 
                        ]
                    }
                  
                ]
                
            }
        ,
   
    {
        path:"/logout",
        element:<Logout />
    }
    ,
    {
        path: "*",
        element: <NotFound />
    }
]);

export default router; 